// removed by extract-text-webpack-plugin
module.exports = {"formula":"dc7_F W_-nV _19fGQ _3HYbc","formulaHeader":"_3-usO _1-OXK _3Xg8b iw2TU _3BXGR _1XY46","formulaTitle":"_1Ia2Q _1Zj0B","formulaDefinitionInner":"eoD7_ _2Eplg"};


//////////////////
// WEBPACK FOOTER
// ./reference/components/Formula.css
// module id = 2239
// module chunks = 3